export const SIZES = {
    SIDENAV_WIDTH: 222,
    HEADER_HEIGHT: 52,
    MOBILE_BREAKPOINT: 1200,
}
